import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import ReportActionTypes from './reports/ActionTypes';

/**
 * Keeps tracks of the ongoing requests that should show a loading overlay.
 * Its value increases for every new request started and when the requests is
 * completed, its value decreases.
 * The overlay is shown when the accumulator is > 0, and hidden when it's 0.
 *
 * @type {number}
 */
let accumulator = 0;

class PageLoadingOverlay extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  // Is Visible?
  getInitialState() {
    return true;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.HOME_STORE_FETCH_HOT_NOW:
      case ActionTypes.HOME_STORE_FETCH_TO_COMPLETE:
      case ActionTypes.HOME_STORE_FETCH_NEVER_SEEN:
      case ActionTypes.GLOSSARY_GET_ALL_TERMS:
      case ActionTypes.GLOSSARY_GET_TERM:
      case ActionTypes.COLLECTIONS_FETCH:
      case ActionTypes.COLLECTION_FETCH:
      case ActionTypes.COLLECTION_ARCHIVED_FETCH:
      case ActionTypes.CATEGORY_STORE_FETCH:
      case ActionTypes.CATEGORY_BY_ID_STORE_FETCH:
      case ActionTypes.CHAPTER_STORE_FETCH_FOR_THEME:
      case ActionTypes.CHAPTER_STORE_FETCH_FOR_COLLECTION:
      case ActionTypes.THEME_STORE_ALL:
      case ActionTypes.THEME_STORE_FIND:
      case ActionTypes.TIMELESS_THEME_STORE_FIND:
      case ActionTypes.GET_ALL_TAGS:
      case ActionTypes.MANUALS_FETCH:
      case ActionTypes.SEARCH_STORE_SEARCH:
      case ActionTypes.USER_STORE_FETCH:
      case ReportActionTypes.REPORT_STORE_FETCH:
      case ReportActionTypes.COLLECTIONS_STORE_FETCH:
      case ActionTypes.PRODUCT_FOCUSES_FETCH:
      case ActionTypes.PRODUCT_FOCUS_FETCH_BY_ID:
      case ActionTypes.PRODUCT_FOCUS_VIEWED:
      case ActionTypes.USER_STORE_UPDATE_LANGUAGE:
        return ++accumulator > 0;

      case ActionTypes.HOME_STORE_FETCH_HOT_NOW_COMPLETED:
      case ActionTypes.GLOSSARY_GET_ALL_TERMS_COMPLETED:
      case ActionTypes.GLOSSARY_GET_TERM_COMPLETED:
      case ActionTypes.COLLECTIONS_FETCH_COMPLETE:
      case ActionTypes.COLLECTION_FETCH_COMPLETE:
      case ActionTypes.COLLECTION_ARCHIVED_FETCH_COMPLETE:
      case ActionTypes.CATEGORY_STORE_FETCH_COMPLETE:
      case ActionTypes.CATEGORY_BY_ID_STORE_FETCH_COMPLETE:
      case ActionTypes.CHAPTER_STORE_FETCH_COMPLETE:
      case ActionTypes.THEME_STORE_ALL_COMPLETE:
      case ActionTypes.THEME_STORE_FIND_COMPLETE:
      case ActionTypes.TIMELESS_THEME_STORE_FIND_COMPLETE:
      case ActionTypes.GET_ALL_TAGS_COMPLETED:
      case ActionTypes.MANUALS_FETCH_COMPLETE:
      case ActionTypes.SEARCH_STORE_SEARCH_COMPLETED:
      case ActionTypes.USER_STORE_FETCH_COMPLETED:
      case ActionTypes.REPORT_STORE_FETCH_ERROR:
      case ReportActionTypes.REPORT_STORE_FETCH_COMPLETE:
      case ReportActionTypes.COLLECTIONS_STORE_FETCH_COMPLETE:
      case ActionTypes.PRODUCT_FOCUSES_FETCH_COMPLETED:
      case ActionTypes.PRODUCT_FOCUS_FETCH_BY_ID_COMPLETED:
      case ActionTypes.PRODUCT_FOCUS_VIEWED_COMPLETED:
      case ActionTypes.USER_STORE_UPDATE_LANGUAGE_COMPLETED:
      case ActionTypes.HOME_STORE_FETCH_TO_COMPLETE_COMPLETED:
      case ActionTypes.HOME_STORE_FETCH_NEVER_SEEN_COMPLETED:
        return --accumulator > 0;

      // In case of a 401 HTTP response, we decrease the accumulator but
      // return the previous "is visible" value to avoid "concurrency" errors
      // (note the decrement after the comparison).
      // What was happening was that the Header was being rendered after setting
      // the user JWT token to `null`, thus generating various exceptions (trying
      // to decode a `null` JWT token for example). This is a workaround that
      // seems to work fine, and allows us to keep everything as is without any
      // major refactor (the main problem is the setTimeout(this.setState, 0) in
      // AppRouter needed to prevent a "Cannot dispatch in the middle of a
      // dispatch"-error. Try to change the line below from "accumulator--" to
      // "--accumulator" to reproduce the error when the JWT expires (thus
      // generating a 401 HTTP response).
      case ActionTypes.ERROR_HTTP_401:
      case ActionTypes.ERROR_HTTP_403:
      case ActionTypes.ERROR_HTTP_404:
      case ActionTypes.ERROR_HTTP_GENERIC:
        return accumulator-- > 0;

      default:
        return state;
    }
  }
}

export default new PageLoadingOverlay();
